import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { TaskStatus } from "@common/types/task";
import { pluralizeWithCount } from "@common/helpers/string";

interface TaskStatusTerminationConfirmationModalProps {
    pendingStatus: TaskStatus | null;
    activeBlockerCount: number | null;
    onConfirm: () => void;
    onCancel: () => void;
    showDontAskAgain?: boolean;
    shouldSkipConfirmation?: boolean;
    onShouldSkipConfirmationChange?: (checked: boolean) => void;
}

export const TaskStatusTerminationConfirmationModal = ({
    pendingStatus,
    activeBlockerCount,
    onConfirm,
    onCancel,
    showDontAskAgain,
    shouldSkipConfirmation,
    onShouldSkipConfirmationChange,
}: TaskStatusTerminationConfirmationModalProps) => (
    <ConfirmationModal
        show={pendingStatus !== null}
        title="Task still has open blockers"
        question={
            <>
                <span>{`This task is blocked by ${pluralizeWithCount("open task", activeBlockerCount ?? 0)}. Are you sure you want to mark it as ${pendingStatus === "done" ? "done" : "cancelled"}?`}</span>
                {showDontAskAgain && (
                    <span className="mt-3 d-block">
                        <Checkbox
                            checked={shouldSkipConfirmation ?? false}
                            label="Don't ask me again"
                            onCheckedChange={(checked) =>
                                onShouldSkipConfirmationChange?.(checked)
                            }
                        />
                    </span>
                )}
            </>
        }
        yes="Yes, proceed"
        no="Cancel"
        onConfirm={onConfirm}
        onReject={onCancel}
        onHide={onCancel}
    />
);
